import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import TranslationsMultipleSelect from './components/TranslationsMultipleSelect';
import { preventDefaultForEnterKey } from 'utils/helpers';
import {
	CreateVideoCategoryContext,
	ICreateVideoCategoryContext,
} from '../../../../../../createVideoCategoryState/createVideoCategoryContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import style from './InputFields.module.scss';

const InputFields: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeName,
		setIDsLanguages,
		setFetchedLanguages,
		name,
		IDsSelectedLanguages,
		translations,
	} = useContext<ICreateVideoCategoryContext>(CreateVideoCategoryContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			name,
			IDsSelectedLanguages,
		});
	}, [name, IDsSelectedLanguages]);

	const submit = async () => {
		const someTranslationIsEmpty = translations.some((translation) => translation.name === '');
		if (someTranslationIsEmpty) {
			changeTypeOfModalWindow('someTranslationIsEmpty');
			return;
		}
		setMainFormValidationFail(false);
		setDataForSubmit({
			name,
			translations,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form
				form={form}
				name="basic"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				onFinishFailed={handleFormValidationFail}
				layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<NameField changeName={changeName} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="translationsHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<Text
						className={style.requiredLabel}
						translationNameSpace="form"
						translationKey="requiredLabel"
						theme="secondary"
						size="s"
						weight="bold"
						display="inline"
					/>
					<TranslationsMultipleSelect
						setIDsLanguages={setIDsLanguages}
						setFetchedLanguages={setFetchedLanguages}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};

export default InputFields;
